import { html } from "../../base/_utils";

export function staffModal(member, path) {
    return html`
        <div class="staff-modal modal fade" tabindex="-1" id="${member.id}-modal" aria-hidden="true" aria-labelledby="#${member.id}-modalLabel" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content  bg-gray-gray  p-3 p-sm-4">
                    <button class="btn-close ms-auto" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-header d-inline-block">
                        <h4 class="modal-title staff-name" id="#${member.id}-modalLabel">${member.name}</h4>
                        <p class="staff-title font-primary-medium mb-0">${member.title}</p>
                    </div>
                    <div class="staff-bio modal-body">
                        <img class="staff-image img-fluid float-end ms-3 mb-3" src="${path}${member.image}" alt="${member.name} headshot" />
                        ${member.bio}
                    </div>
                </div>
            </div>
        </div>
    `;
}
